import { ref, onBeforeUnmount } from 'vue';

export const useDetailExpand = () => {
  const isDetailExpanded = ref(false);

  const toggleDetailExpand = () => {
    isDetailExpanded.value = !isDetailExpanded.value;
  };

  const closeDetailExpand = () => {
    isDetailExpanded.value = false;
  };

  const isModalOpen = () => {
    const visibleModal = document.querySelector('.modal.show, .modal.fade.show');
    if (visibleModal) {
      return true;
    }

    const backdrop = document.querySelector('.modal-backdrop');
    return !!backdrop;
  };

  const onKeydown = (event) => {
    if (event.key !== 'Escape') {
      return;
    }
    if (!isDetailExpanded.value) {
      return;
    }
    if (isModalOpen()) {
      return;
    }
    event.preventDefault();
    closeDetailExpand();
  };

  document.addEventListener('keydown', onKeydown);

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', onKeydown);
  });

  return {
    isDetailExpanded,
    toggleDetailExpand,
    closeDetailExpand,
  };
};
